<div class="modal-container">
  <div class="modal-header">
    <div class="modal-header-left">
      <span class="modal-title">{{ 'tire.modal-add-tire.title' | translate }}</span>
      <span class="modal-subtitle">{{ 'tire.modal-add-tire.subtitle' | translate }}</span>
    </div>
    <button class="close-button" (click)="closeModal()">✕</button>
  </div>

  <div class="modal-body">
    <div class="filters-row">

      <!-- Seat Filter -->
      <div class="filter-item seat select-wrapper">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'tire.modal-add-tire.seat' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedSeat"
                      (selectionChange)="applySeatFilter()"
                      [class.has-value]="selectedSeat !== undefined"
                      [placeholder]="'tire.modal-add-tire.selectSeat' | translate"
                      [panelClass]="'select-panel'">
          <mat-option [value]="undefined">{{ 'tire.modal-add-tire.selectSeat' | translate }}</mat-option>
          @for (seat of filteredSeats; track seat) {
            <mat-option [value]="seat"> {{ seat }} </mat-option>
          }
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Manufacturer Filter -->
      <div class="filter-item manufacturer select-wrapper">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'tire.modal-add-tire.manufacturer' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedManufacturer"
                      (selectionChange)="applyManufacturerFilter()"
                      [class.has-value]="selectedManufacturer !== undefined"
                      [placeholder]="'tire.modal-add-tire.selectManufacturer' | translate"
                      [panelClass]="'select-panel'">
          <mat-option [value]="undefined">{{ 'tire.modal-add-tire.selectManufacturer' | translate }}</mat-option>
          @for (manu of filteredManufacturers; track manu) {
            <mat-option [value]="manu">{{ manu }}</mat-option>
          }
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Search Input + Autocomplete -->
      <div class="filter-item search-item">
        <div class="search-wrapper" (click)="$event.stopPropagation()">
          <div class="filter-item search-item">
            <app-autocomplete class="search-autocomplete"
                              [placeholder]="'tire.modal-add-tire.specificationName' | translate"
                              [label]="('tire.modal-add-tire.specificationName' | translate)"
                              [filterCtrl]="filterCtrl"
                              [filteredList$]="filteredTireSpec$"
                              [isLoading]="isLoading"
                              [valueKey]="'id'"
                              [displayKey]="'specificationFull'"
                              (elementSelected)="onElementSelected($event)"/>
          </div>
        </div>
      </div>

    </div>

    <!-- Table -->
    <div class="table-container">
      @if (isTableLoading) {
        <div class="table-loading">
          <mat-progress-spinner
            mode="indeterminate"
            diameter="50">
          </mat-progress-spinner>
        </div>
      }
      @else {
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>{{ 'tire.modal-add-tire.select' | translate }}</th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox (change)="toggleSelection(row)" [checked]="selection.includes(row)"></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="seat">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'tire.modal-add-tire.seat' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.seat }}</td>
          </ng-container>

          <ng-container matColumnDef="manufacturer">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'tire.modal-add-tire.manufacturer' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.manufacturer }}</td>
          </ng-container>

          <ng-container matColumnDef="specificationFull">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'tire.modal-add-tire.specification' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.specificationFull }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      }
    </div>

    <!-- Table Footer -->
    <div class="table-footer-row">
      <span class="selected-items">{{ 'tire.modal-add-tire.selectedItems' | translate:{count: selection.length} }}</span>
      <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>
    </div>
  </div>

  <!-- Modal Actions -->
  <div class="modal-actions">
    <button class="cancel-button" (click)="closeModal()">{{ 'tire.modal-add-tire.cancel' | translate }}</button>
    <button
      class="add-button-tire"
      [disabled]="selection.length === 0 || isSubmitting"
      (click)="addTireSpecifications()">

      @if (!isSubmitting) {
        {{ 'tire.modal-add-tire.addTire' | translate:{count: selection.length} }}
      } @else {
        <mat-progress-spinner
          diameter="18"
          mode="indeterminate">
        </mat-progress-spinner>
      }
    </button>
  </div>
</div>
